import { Component, OnInit } from '@angular/core';
import { AlertController, LoadingController, ModalController, NavParams } from '@ionic/angular';
import { OadvService } from 'src/app/services/oadv.service';
import CONFIG  from '../../config';
@Component({
  selector: 'app-visualizar-pdf',
  templateUrl: './visualizar-pdf.page.html',
  styleUrls: ['./visualizar-pdf.page.scss'],
})
export class VisualizarPdfPage implements OnInit {

  public documento:any={};
  public url= CONFIG.API + '/imagesoadv/'
  public zoom:number=0.6;
    constructor(private modalController:ModalController, 
      private loadingController:LoadingController,
      private alertController:AlertController, 
      private oadvService:OadvService, private navParams:NavParams ) { }
  
    ngOnInit() {
      this.oadvService.getDocumento(this.navParams.get('idDocumento'))
      .then(document=>{
        this.documento=document;
      })
    }
  
    async cerrar(){
      this.modalController.dismiss();
    }

    masZoom(){
      if(this.zoom){
        this.zoom+=.1;
      }
    }

    menosZoom(){
      if(this.zoom > 0.3 ){
        this.zoom-=.1;
      }
    }
  
    async eliminar(){
      const alert = await this.alertController.create({
        header: 'Eliminación de documento OADV',
        message: '¿Estás seguro de eliminar el documento?',
        buttons: [
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
              console.log('Confirm Cancel: blah');
            }
          }, {
            text: 'Eliminar',
            handler: async () => {
                const loading = await this.loadingController.create({
                  message: 'Eliminando documento...',
                  spinner: 'lines'
                });
                await loading.present();
                this.oadvService.eliminarDocumento(this.documento.id_documento)
                .then((ok)=>{
                  loading.dismiss();
                  this.mensajes('Documentos OADV','','Se ha eliminado con éxito el doumento');
                  this.modalController.dismiss({
                    delete:true
                  })
                 
                })
                .catch(err=>{
                  loading.dismiss();
                })
            }
          }
        ]
      });
    
      await alert.present();
    }

    async mensajes(header, subHeader, message) {
      const alert = await this.alertController.create({
        header: header,
        subHeader: subHeader,
        message: message,
        buttons: ['Aceptar']
      });
  
      await alert.present();
    }
  
}
